<template>
  <div class="hello" @click="handleBtnClick" v-touch:swipe="handleBtnClick">
    <img src="./../assets/DSJSR_header.jpg" style="width: 100%" />
    <div style="width: 95%; margin: auto; height: 95%">
      <HscrollAlt :start="start" :showAll="false" speed="slow">
        <div v-show="contentObj" >
        <ImgVideoCommon v-for="(item, key, index) in contentObj" v-bind:key="index" :imgSrc="item.imgSrc" :videoTitle="item.videoTitle" :videoSrc="item.videoSrc"/>
        </div>
      </HscrollAlt>
    </div>
    <div class="hint-container" v-if="!start">
      <DownHint :start="start" :downHintTxt="downHintTxt" :theme="theme" />
    </div>
  </div>
</template>

<script>
import HscrollAlt from "./HscrollAlt";
import DownHint from "./DownHint";
import ImgVideoCommon from "./ImgVideoCommon";

export default {
  components: {
    HscrollAlt,
    DownHint,
    ImgVideoCommon
  },
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      start: false,
      downHintTxt: "我是党史讲述人",
      theme: "red",
      hls: "",
      contentObj: null
    };
  },
  mounted() {
    this.axios.get("./js/dsjsr/WSDSJSRCommon.json").then((res) => {
        this.contentObj = res.data;
      });
  },
  methods: {
    handleBtnClick() {
      this.start = true;
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.hello {
  max-height: 100%;
  height: 80vh;
}
.hint-container {
  width: 100%;
  position: absolute;
  top: 30%;
}
</style>
